import { css } from '@emotion/core'
import React from 'react'

import ThirdPartyGuard from './ThirdPartyGuard'

export const HippoVideo: React.FC<{ hippoVideoId: string }> = ({ hippoVideoId }) => {
  return (
    <div css={containerStyle}>
      <ThirdPartyGuard blackBG>
        <iframe
          allow="encrypted-media *"
          css={iframeStyle}
          allowTransparency={true}
          src={`https://ala.hippovideo.io/video/embed/${hippoVideoId}?org_tok=RCD1rMqGjOMdt1cS4H1ggg&autoplay=false`}
          frameBorder="0"
          allowFullScreen
          scrolling="no"
        />
      </ThirdPartyGuard>
    </div>
  )
}

const containerStyle = css`
  width: 100%;
  height: null;
  position: relative;
  padding-top: 56.25%;
`

const iframeStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  form {
    background-color: green;
  }
`
